import React, { useState } from 'react';
import { MyTickets, RaisedTickets } from './TicketsTables';
import Dashboardnavbarcopy from '../../layout/Dashboardnavbarcopy';
import { useLocation } from 'react-router-dom';

const TicketsManagement = () => {
    const location = useLocation();
    const loctoggleState = location.state !== null ? location.state?.toggleState ? location.state?.toggleState : 1 : 1;

    const [toggleState, setToggleState] = useState(loctoggleState);
    const getSelectedTitle = () => {
        switch (toggleState) {
            case 1:
                return 'My Tickets';
            case 2:
                return 'Raised Tickets';;
            default:
                return 'My Tickets';
        }
    };

    return (
        <>
            <Dashboardnavbarcopy name={getSelectedTitle()} url="Tickets Managment" />
            {sessionStorage.getItem('department') === 'b3e3afd9-97e4-402f-85eb-4c22599ee5e8' ?
                <div className="bloc-tabss2  wfm-margin">
                    <button
                        className={toggleState === 1 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading    dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   "}
                        onClick={() => setToggleState(1)}
                    >
                        My Tickets
                    </button>
                    < button
                        className={toggleState === 2 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading    dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   "}
                        onClick={() => setToggleState(2)}
                    >
                        Raised Tickets
                    </button>
                </div>
                : null
            }
            <div>
                {toggleState === 1 ? <MyTickets /> : null}
                {toggleState === 2 ? <RaisedTickets /> : null}
            </div>
        </>
    );
};

export default TicketsManagement;